export default __webpack_public_path__ + "static/media/litho-inner-page-slider-02.38e1b67e.jpg";